import { Box, Typography, styled } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useChatContex } from '../../../contex/ChatContex'
import { ConversationBetweenTwo, getConversation } from '../../../server/Server'
import { ThirtyFpsSelect } from '@mui/icons-material'
import { formatDate } from '../../../Utils/UsabaleUtil'




const Components = styled(Box)`
    height: 45px;
    display: flex;
    padding: 13px 0;
    cursor: pointer;
`;

// const Image=styled("img")({
//     width:50,
//     height:50,
//     borderRadius:"50%",
//     padding:'0 14px',
//     objectFit:"cover",
// })

const Image = styled('img') ({
   width: 50,
   height: 50,
   objectFit: 'cover',
   borderRadius: '50%',
   padding: '0 14px'
});


const Timestamp = styled(Typography)`
    font-size: 12px;
    margin-left: auto;
    color: #00000099;
    margin-right: 20px;
`;

const Text = styled(Typography)`
    display: block;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
`;

const Container = styled(Box)`
    display: flex;
    
`;









function ConversationData({user}) {

   const[message,SetMessage]=useState({})

const {personData,PersonData,login,ConverSationData,Convesation,GetMessage,Sette,te}=useChatContex()



useEffect(()=>{
   const getConversationDetails=async()=>{

    const data = await getConversation({SenderId:login.sub,ReceivedId:user.sub})


    SetMessage({text:data[0]?.message ,timestamp:data[0]?.updatedAt})
   }
   getConversationDetails()
},[te])

const getUser= async(data)=>{


   try {

    await ConverSationData({senderId:login.sub,ReceivedId: data.sub,})


    const Conver={
        SenderId:login.sub,
        ReceiverId:data.sub
    }
   
   await  personData(data)
   
   await ConversationBetweenTwo(Conver)

    
   } catch (error) {
     console.log(error)
     
   }

}




    return (
        <Components onClick={()=>getUser(user)}>
           <Box>
              <Image src={user.img}></Image>
           </Box>
           <Box style={{width: '100%'}}>
              <Container>
                 <Typography>{user.name}</Typography>
                {
                  message?.text && 
                  <Timestamp>{formatDate(message?.timestamp)}</Timestamp>
                }
              </Container>
              <Box>
                 <Text>{message?.text?.includes('localhost')? 'media' : message.text}</Text>
              </Box>
           </Box>
        </Components>
    )
}

export default ConversationData
